import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  approve: {
    [LanguagesEnum.English]: 'Approve',
    [LanguagesEnum.Greek]: 'Αποδοχή',
  },
  reject: {
    [LanguagesEnum.English]: 'Reject',
    [LanguagesEnum.Greek]: 'Απόρριψη',
  },
  approve_reject: {
    [LanguagesEnum.English]: 'Approve/Reject',
    [LanguagesEnum.Greek]: 'Αποδοχή/Απόρριψη',
  },
  submit: {
    [LanguagesEnum.English]: 'SUBMIT',
    [LanguagesEnum.Greek]: 'ΥΠΟΒΟΛΗ',
  },
};

export default CONFIGURATION;
